<template>
    <div v-if="viewNavBar()" class="bottom-nav" ref="bottomNav">
        <!-- <div class="nav-button">
            <div class="icon-with-badge" @click="$router.push({ path: '/private-inbox' })">
                <v-icon color="#d0cfcd" id="step4" size="36"> mdi-chat-processing </v-icon>
                <div v-if="nostrMessageStore.totalUnreadMessages > 0" class="badge">
                    {{ nostrMessageStore.totalUnreadMessages }}
                </div>
            </div>
        </div> -->

        <div class="nav-button">
            <span
                class="pb-1"
                style="font-size: 28px !important"
                @click="goTo('/post-feed-view?type=challenge&reset')"
            >
                🏆</span
            >
        </div>

        <div class="nav-button">
            <span class="pb-1" style="font-size: 28px !important" @click="goTo('/search')">
                🔎</span
            >
        </div>

        <div class="nav-button">
            <span
                class="pb-1"
                style="font-size: 28px !important"
                @click="$router.push({ path: '/create-content', query: { type: 'challenge' } })"
            >
                ✨</span
            >
        </div>

        <div class="nav-button">
            <div
                class="icon-with-badge"
                @click="$router.push('/notifications')"
                title="Notifications"
            >
                <span style="font-size: 28px !important">🔔</span>
                <!-- <span>🪧</span> -->

                <div v-if="unreadNotifications > 0" class="badge">
                    {{ unreadNotifications > 99 ? '99+' : unreadNotifications }}
                </div>
            </div>
        </div>

        <div class="nav-button" v-if="userProfile.id">
            <ProfilePhoto
                id="step3"
                class="mr-2"
                :username="userProfile.username"
                :profile_photo="userProfile.profile_photo"
                size="small"
                @click="navigateTo($router, '/user-management')"
            />
        </div>

        <div v-else class="nav-button2 mr-2">
            <a @click="duellyEventEmitter.emit('show-login-overlay')">Login</a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import ProfilePhoto from '@/components/ProfilePhoto.vue';
import { duellyEventEmitter } from '@/services/eventBus';
import { useAuthStore } from '@/store/authStore';
import { useNostrMessageStore } from '@/store/nostrMessageStore';
import { useNoticeStore } from '@/store/noticeStore';

import { navigateTo, navigateToFeed } from './utils';

const route = useRoute();
const authStore = useAuthStore();
const noticeStore = useNoticeStore();
const nostrMessageStore = useNostrMessageStore();

const userProfile = ref(authStore.getUserProfile());

const bottomNav = ref();
const showFeedPopup = ref(false);

defineExpose({ bottomNav }); // So parent can read height if needed

const unreadNotifications = computed(() => {
    const resp = noticeStore.unreadCount;
    return resp;
});

function goTo(path: string) {
    showFeedPopup.value = false;
    window.location.href = path;
}

const viewNavBar = () => {
    userProfile.value = authStore.getUserProfile();
    if (route.path === '/login' || route.path === '/' || route.path.startsWith('/admin')) {
        return false;
    } else {
        return true;
    }
};

onMounted(async () => {
    // Listen for login event
    await noticeStore.fetchNotifications(null, 1000);
});
</script>

<style scoped lang="scss">
@use '@/assets/scss/abstracts/variables' as *;
@use '@/assets/scss/global' as *;

.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    height: $bottom-nav-bar-size;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #111111;
    box-sizing: border-box;
    // border-top: 1px solid red;

    @media (min-width: $desktop-max-width) {
        display: none;
    }
}

.nav-button {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
}

.bottom-nav .nav-button > span {
    font-size: 28px !important;
    line-height: 28px;
    width: 28px;
    height: 28px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.nav-button:active {
    opacity: 0.5;
}

.upload-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.icon-with-badge {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bell-icon {
    font-size: 28px;
    color: white;

    @media (min-width: $desktop-max-width) {
        font-size: 48px;
    }
}

.badge {
    position: absolute;
    top: 2px;
    right: -2px;
    background-color: #ff5c45;
    color: white;
    font-size: 10px;
    font-weight: bold;
    border-radius: 50%;
    min-width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    padding: 0 4px;

    @media (min-width: $desktop-max-width) {
        font-size: 48px;
        font-size: 20px;
        min-width: 24px;
        height: 24px;
        line-height: 24px;
    }
}

.feed-button {
    position: relative; // anchor the popup to this button
}

.popup-nav-choice {
    position: absolute;
    bottom: $bottom-nav-bar-size;
    left: 50%;
    transform: translateX(-30%);
    background-color: #222;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
    z-index: 999;
    padding: 6px 0;
    width: 160px;

    display: flex;
    flex-direction: column;
    align-items: stretch;

    div {
        padding: 10px 16px;
        color: white;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        cursor: pointer;
        // transition: background 0.2s ease;

        &:hover {
            background-color: #333;
        }

        &:active {
            background-color: #444;
        }
    }
}
</style>
